var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.827,
    height: 25.262,
    viewBox: "0 0 30.827 25.262",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.535 -2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.221,26.869h19.13l3.281-3.036L30.889,20.6l-.628-4.1-2.653-3.451s-2.025-1.222-2.234-2.085-.489-2.948-.7-3.523S23.418,6.363,22.79,5.788a11.85,11.85,0,0,0-2.862-1.225c-.978-.428-1.816.572-3.561,0a4.771,4.771,0,0,0-3.491,0c-1.047.29-.907-.07-1.675.937A26.074,26.074,0,0,0,9.316,7.945a32.053,32.053,0,0,0-1.187,3.019c-.7,1.582-1.186,2.731-1.4,3.019a22.058,22.058,0,0,1-1.676,1.438c-.489.431-.838,0-1.257,1.078s-.7.863-.768,2.013-.419,1.438,0,2.373.768,1.941.768,1.941a4.934,4.934,0,0,0,.489,1.51,4,4,0,0,0,1.4,1.078C5.895,25.559,7.221,26.869,7.221,26.869Z",
    transform: "translate(0 0.047)",
    fill: "rgba(51,201,156,0.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.059,26.262c4.044,0,6.768-3.322,6.768-7.42a7.425,7.425,0,0,0-4.44-6.824A9.3,9.3,0,0,0,15.913,4c-5.258,0-9.52,3.987-9.52,8.9q0,.189.008.377a6.676,6.676,0,0,0-4.4,6.3c0,3.688,2.544,6.678,6.184,6.678",
    transform: "translate(1.035)",
    fill: "none",
    stroke: "#1bcc96",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.264 18.274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.539,7.519,13.519,4.5,10.5,7.519",
    transform: "translate(-10.5 -4.5)",
    fill: "none",
    stroke: "#1bcc96",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,4.5v8.642",
    transform: "translate(-14.981 -4.5)",
    fill: "none",
    stroke: "#1bcc96",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.1200a182ae9b7ea1540b38598ff7946b.svg";
export { ForwardRef as ReactComponent };